import React, { useEffect } from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import useAuthStore from "../../features/auth/authStore.client"
import { useDelayedLoading } from "../hooks/useDelayedLoading"
import Loader from "../base/Loader"

interface PrivateRouteProps {
  requiredRole?: string
  requiredRoles?: string[]
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ requiredRole, requiredRoles }) => {
  const location = useLocation()

  // Destructure required state and actions from the auth store
  const { user, loading, isAuthReady, checkAuth } = useAuthStore()

  // Delay loader until either loading is false and auth is ready
  const showLoader = useDelayedLoading(loading || !isAuthReady)

  // Check auth status on mount
  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  // Show loader if we're still checking auth
  if (showLoader) {
    return <Loader variant="fullScreen" />
  }

  // If no user is found after auth check, redirect to login page.
  if (!user) {
    return <Navigate to="/se-connecter" state={{ from: location }} />
  }

  // If a required role is specified and doesn't match, redirect to unauthorized.
  const allowedRoles = requiredRoles || (requiredRole ? [requiredRole] : [])
  if (allowedRoles.length && !allowedRoles.includes(user.role)) {
    return <Navigate to="/app" replace />
  }

  // Otherwise, render the protected child routes.
  return <Outlet />
}

export default PrivateRoute
